import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Grid,
  Divider,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/Atithiseva-Logo-Final-1024x298.png";
import { formatDateWithAmPm } from "../../Style";
import "../../styles/UserStyles.css";
import "../../styles/Payment.scss";
import { useDispatch, useSelector } from "react-redux";
import { fetchBookingRequest } from "../../redux/Bookings/BookingAction";
import {
  addRemarksRequest,
  fetchRemarksRequest,
  resetInvoiceDetails,
} from "../../redux/Invoice/InvoiceAction";

function PaymentDetail() {
  const location = useLocation();
  const dispatch = useDispatch();
  const bookingId = location.state?.invoiceId;
  const navigate = useNavigate();

  const user = useSelector((state) => state.auth.user);
      const searchQuery=location.state.searchQuery??"";
  const paymentDetails = useSelector(
    (state) => state.booking?.booking?.data[0]
  );
 
const page= location.state?.page?? 1;

  useEffect(() => {
    dispatch(resetInvoiceDetails());
    dispatch(fetchBookingRequest(bookingId));
  }, [bookingId]);
  const currencyFormatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
  });
  if (!PaymentDetail)
    return <Typography>Invoice details not available.</Typography>;
  // caluculation
  const servicePrice = paymentDetails?.Order?.price;
  const adultFamilyMember = paymentDetails?.bookingFamilies?.filter((adult) => {
    return adult?.familyMember?.age >= 12;
  });

  const infantFamilyMember = paymentDetails?.bookingFamilies?.filter(
    (infant) => {
      return infant?.familyMember?.age < 2;
    }
  );
  const childFamilyMember = paymentDetails?.bookingFamilies?.filter((child) => {
    return child?.familyMember?.age >= 2 && child?.familyMember?.age < 12;
  });
  const totalPassenger =
    adultFamilyMember?.length +
    childFamilyMember?.length +
    infantFamilyMember?.length;
 
  const adultDiscount = adultFamilyMember?.[0]?.familyMember?.discount || 0;
  const childDiscount = childFamilyMember?.[0]?.familyMember?.discount || 0;
  const infantDiscount = infantFamilyMember?.[0]?.familyMember?.discount || 0;

  const isVendor =
    paymentDetails?.BookingDetail?.booked_user_type === 2 &&
    (user?.role === "Admin" ||
      user?.role === "Staff" ||
      user?.role === "Vendor");

  const orderSource = isVendor
    ? paymentDetails?.vendorBookLogs?.[0]
    : paymentDetails?.Order;
  const sgstPercentage = (
    (orderSource?.sgst / orderSource?.sub_total) * 100 || 0
  ).toFixed(0);
  const cgstPercentage = (
    (orderSource?.cgst / orderSource?.sub_total) * 100 || 0
  ).toFixed(0);
  const taxPercentage = (
    (paymentDetails?.Order?.tax / orderSource?.sub_total) * 100 || 0
  ).toFixed(0);

  const GrossAmount = parseFloat(
    paymentDetails?.BookingDetail?.number_of_service*
      paymentDetails?.Order?.price
  );
  const AdultPrice = -parseFloat(
    adultFamilyMember?.length * (adultDiscount / 100) * servicePrice
  );
  const ChildPrice = -parseFloat(
    childFamilyMember?.length * (childDiscount / 100) * servicePrice
  );
  // const InfantPrice = -parseFloat(
  //   infantFamilyMember?.length * (infantDiscount / 100) * servicePrice
  // );
  const subTotalWithoutAmount =
    GrossAmount + AdultPrice + ChildPrice ;
  const subTotal = orderSource?.sub_total;

  const instantBookingCharge = paymentDetails?.Order?.additional_payment;

  const discountPercentage = paymentDetails?.Order?.discount;
  const remarks = paymentDetails?.Order?.remarks;
  return (
    <Box className="payment-detail-container">
      <Paper className="payment-detail-paper">
        <Box className="payment-header">
          <img src={Logo} alt="Atithiseva Logo" className="logo" />
          <Typography variant="h5" className="payment-header-title">
            Invoice Detail
          </Typography>
        </Box>

        <Box className="payment-info-box">
          <Typography variant="subtitle1">
            Status :{" "}
            <span
              className={`payment-status ${
                paymentDetails?.payment_status === 1
                  ? "completed"
                  : paymentDetails?.payment_status === 0 &&
                    paymentDetails?.booked_type === 2
                  ? "completed"
                  : paymentDetails?.payment_status === 2
                  ? "failure"
                  : paymentDetails?.payment_status === 3
                  ? "refunded"
                  : paymentDetails?.payment_status === 0
                  ? "pending"
                  : "aborted"
              }`}
            >
              {paymentDetails?.payment_status === 1
                ? "completed"
                : paymentDetails?.payment_status === 0 &&
                  paymentDetails?.booked_type === 2
                ? "Free Complementary"
                : paymentDetails?.payment_status === 2
                ? "Failed"
                : paymentDetails?.payment_status === 3
                ? "Refunded"
                : paymentDetails?.payment_status === 0
                ? "Pending"
                : "Aborted"}
            </span>
          </Typography>
        </Box>

        <Divider />

        <Box className="payment-details">
          {[
            {
              label: "Customer Name",
              value: paymentDetails?.Customer?.full_name,
            },
            { label: "Payment Id", value: paymentDetails?.pnr_number },
            { label: "Booking Id", value: paymentDetails?.booking_serial_no },

            // { label: 'Payment Method', value: 'UPI' },
            {
              label: "Gross Amount",
              value: currencyFormatter.format( paymentDetails?.BookingDetail?.number_of_service * servicePrice),
            },
            adultFamilyMember?.length > 0 && {
              label: `Adult Discount (${adultDiscount}%)`,
              value: currencyFormatter.format(AdultPrice),
            },
            childFamilyMember?.length > 0 && {
              label: `Child Discount (${childDiscount}%)`,
              value: currencyFormatter.format(ChildPrice),
            },
            // infantFamilyMember?.length > 0 && {
            //   label: `infant Discount (${infantDiscount}%)`,
            //   value: currencyFormatter.format(InfantPrice),
            // },

            user?.role !== "Customer" &&
              orderSource?.vendor_commision_rate > 0 && {
                label: `Vendor Commission (${orderSource?.vendor_commision_rate}%)`,
                value: currencyFormatter.format(
                  -orderSource?.vendor_commision || 0
                ),
              },
            discountPercentage > 0 && {
              label: `Booking Discount (${discountPercentage} %)`,
              value: `- ${currencyFormatter.format(
                subTotalWithoutAmount * (discountPercentage / 100)
              )}`,
            },

            paymentDetails?.totalPenaltyCharge > 0 && {
              label: "Amendment Charge (Included Taxes)",
              value: currencyFormatter.format(
                paymentDetails?.totalPenaltyCharge
              ),
            },
            instantBookingCharge > 0 && {
              label: "Instant Booking Charge",
              value: currencyFormatter.format(instantBookingCharge),
            },
            {
              label: "SubTotal",
              value: currencyFormatter.format(subTotal),
            },
            
            cgstPercentage > 0 && {
              label: `CGST (${cgstPercentage} %)`,
              value: currencyFormatter.format(orderSource?.cgst),
            },
            sgstPercentage > 0 && {
              label: `SGST (${sgstPercentage} %)`,
              value: currencyFormatter.format(orderSource?.sgst),
            },
            paymentDetails?.Order?.tax > 0 && {
              label: `IGST (${taxPercentage}%)`,
              value: currencyFormatter.format(
                parseFloat(paymentDetails?.Order?.tax) || 0
              ),
            },

            {
              label: "TOTAL",
              value: currencyFormatter.format(
                isVendor
                  ? paymentDetails?.totalVendorBookingCharge
                  : paymentDetails?.totalBookingCharge
              ),
            },
          ]
            .filter(Boolean)
            .map((item, index) => (
              <Grid container key={index} className="payment-grid">
                <Grid item xs={6}>
                  <Typography variant="body1" className="payment-label">
                    {item.label}
                  </Typography>
                </Grid>
                <Grid item xs={6} className="payment-value-container">
                  <Typography variant="body1" className="payment-value">
                    {item.value}
                  </Typography>
                </Grid>
              </Grid>
            ))}
        </Box>

        <Divider />
        {(user.role === "Admin" || user.role === "Staff") && (
          <>
            <Box
              sx={{
                mb: 5,
                px: 2,
                padding: "16px 20px",
                backgroundColor: "#f9f9f9",
              }}
            />

            <Box sx={{ px: 2 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Remarks
              </Typography>
              <TextField
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                value={remarks}
                InputProps={{
                  readOnly: true,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    backgroundColor: "#f8f8f8",
                  },
                }}
              />
            </Box>
          </>
        )}

        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            mt: 2,
            padding: "20px",
          }}
        >
          <Button
            variant="contained"
            className="orange-button"
           onClick={() => navigate("/invoices",{state:{page:page,searchQuery:searchQuery}})}
          >
            Back
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default PaymentDetail;
